import axios from "axios";
import { AxiosError } from 'axios';

export const apiLogin = async (formData: any, clinic: string) => {
    try {
        const { data } =  await axios.post(
            route("embed.login", { clinic: clinic }),
            formData
        );
        return data;
    } catch (e: unknown) {
        const error = e as AxiosError;

        if (error.response && error.response.data) {
            return error.response.data;
        }
        
        return { errors: true, message: 'Something went wrong, please try again.' };
    }
}